export const mx = {
    "textDictionary": {
        "COMBO_GTD_MANQUEHUE_LABEL": "GTD Manquehue",
        "FILTERS_TITLE_REBRANDING_MOBILE": "Filtrar por:",
        "ORDER_BY_DESKTOP": "Ordenar por",
        "OF": "de",
        "Results": "Resultados",
    },
    "toggles": {
        "NEW_PROMOTION_CALL": false,
        "disableSponsoredProducts": true,
        "isDynamicFacetsEnabled": true,
    }
}